import { render, staticRenderFns } from "./taskSucceed.vue?vue&type=template&id=1547f5a0&scoped=true&"
import script from "./taskSucceed.vue?vue&type=script&lang=js&"
export * from "./taskSucceed.vue?vue&type=script&lang=js&"
import style0 from "./taskSucceed.vue?vue&type=style&index=0&id=1547f5a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1547f5a0",
  null
  
)

export default component.exports